<template>
  <v-menu
    class="rounded-te"
    location="bottom left"
    open-on-hover
    :offset="[-5, -15]"
    transition="slide-y-transition"
  >
    <template #activator="{ props }">
      <v-btn
        class="base-item-button ma-2 pa-0"
        variant="flat"
        size="medium"
        color="white"
        v-bind="props"
      >
        <v-icon icon="$dots-vertical" />
      </v-btn>
    </template>
    <v-list class="pa-0 base-item-options-list">
      <v-list-item
        v-for="{ name, label } in menuItems"
        :key="name"
        class="base-list-item d-flex align-center"
        @click="emitMenuClick(name, item.id, item.name)"
      >
        <v-list-item-title>{{ label }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>

export default {
  name: 'MenuList',
  props: {
    item: { type: Object, default: () => ({}) },
    menuItems: { type: Array, default: () => [] },
  },
  emits: ['menuClick'],
  methods: {
    emitMenuClick(methodName, id, itemName) {
      this.$emit('menuClick', methodName, id, itemName);
    },
  },
};
</script>

<style scoped lang="less">
@import '@/less/mixins';
.v-btn {
  text-transform: none !important;
}
.v-btn::before {
  background-color: @white;
}
.base-item-button {
  border-left: 2px solid #eff0f1!important;
  height: 100% !important;
  margin: 0!important;
  min-width: 54px;
  width: 54px;
  border-radius: 0;
  :deep(.v-icon) {
    color: @grey-500;
  }
}
.base-item-button:hover .v-icon {
  color: @text-brand;
}

.base-list-item.v-list-item {
  color: @text-darkest;
  border-bottom: 1px solid @stroke-default;
  min-height: 40px;
  height: 40px;
  white-space: nowrap;
  font-weight: 300;
  -webkit-font-smoothing: antialiased;

  :deep(.v-list-item-title) {
    font-weight: inherit;
  }
}

.base-list-item.v-list-item:hover {
  background: @bg-canvas;
  cursor: pointer;

  > :deep(.v-list-item__overlay) {
    background: @bg-canvas;
  }
}

.v-menu > .v-overlay__content > .v-list {
  box-shadow: 0 10px 50px 0 fade(@grey-900, 10%);
  border-radius: 6px;
}
</style>
